import ContentTypeSDK from "../../../../src/mdx/sdk/content-types.mdx";
import * as React from 'react';
export default {
  ContentTypeSDK,
  React
};